import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NavBar from "./components/NavBar.jsx";
import ProtectedRoute from "./components/ProtectedRoute.jsx";
import { NavBarTitleProvider } from "./contexts/NavBarTitleContext.jsx";
import AddUsersPage from "./pages/AddUsersPage.jsx";
import AuthCallback from "./pages/AuthCallback.jsx";
import ChangeManagement from "./pages/ChangeManagement/ChangeManagement.jsx";
import CompanyDetails from "./pages/CompanyDetails.jsx";
import CompanyProjectsHome from "./pages/CompanyProjectsHome.jsx";
import Forecast from "./pages/Forecast.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import ProjectDetails from "./pages/ProjectDetails.jsx";
import Settings from "./pages/Settings.jsx";
import { apiRequest } from "./utils/apiRequest";
import ErrorBoundary from "./components/ErrorBoundary.jsx";

function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <NavBarTitleProvider>
        <NavBar />
      </NavBarTitleProvider>
    </ProtectedRoute>
  );
}

function App() {
  useEffect(() => {
    const fetchCsrf = async (retries = 3) => {
      for (let i = 0; i < retries; i++) {
        try {
          await apiRequest(`${process.env.REACT_APP_API_BASE_URL}/get-csrf/`, {
            method: "GET",
            suppressErrorToast: true,
          });
          return;
        } catch {
          if (i < retries - 1) await new Promise((r) => setTimeout(r, 1000 * (i + 1)));
        }
      }
    };
    fetchCsrf();
  }, []);

  return (
    <ErrorBoundary>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route element={<ProtectedLayout />}>
            <Route path="/home" element={<CompanyProjectsHome />} />
            <Route path="/project/:companyId/:projectId" element={<ProjectDetails />} />
            <Route path="/company/:companyId" element={<CompanyDetails />} />
            <Route path="/forecast" element={<Navigate to="/home" replace />} />
            <Route path="/forecast/:companyId/:projectId" element={<Forecast />} />
            <Route path="/change-management" element={<Navigate to="/home" replace />} />
            <Route path="/change-management/:companyId/:projectId" element={<ChangeManagement />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/add-users" element={<AddUsersPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </LocalizationProvider>
    </ErrorBoundary>
  );
}

export default App;
